import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { VipCommission } from "../../modules/vipCommission/components/VipCommission";

const VipCommissionContext = createContext();

const VipCommissionWrapper = () => {
  const value = {};

  return (
    <VipCommissionContext.Provider value={value}>
      <Routes>
        <Route path="" element={<VipCommission />} />
      </Routes>
    </VipCommissionContext.Provider>
  );
};

export { VipCommissionWrapper };
